import Nullstack from 'nullstack';
export default function IconSpider({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-spider",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5 4v2l5 5"
  }), "   ", Nullstack.element("path", {
    d: "M2.5 9.5l1.5 1.5h6"
  }), "   ", Nullstack.element("path", {
    d: "M4 19v-2l6 -6"
  }), "   ", Nullstack.element("path", {
    d: "M19 4v2l-5 5"
  }), "   ", Nullstack.element("path", {
    d: "M21.5 9.5l-1.5 1.5h-6"
  }), "   ", Nullstack.element("path", {
    d: "M20 19v-2l-6 -6"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "15",
    r: "4"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "9",
    r: "2"
  }), " ");
}